import React from 'react';
import './Leadership.css';

const Leadership = () => {
  return (
    <div className="leadership-page">
      <div className="leadership-hero">
        <div className="hero-content">
          <h1 className="hero-title">League Leadership</h1>
          <p className="hero-subtitle">The dedicated team guiding The Golden Goose Fantasy Football League</p>
        </div>
      </div>
      
      <div className="leadership-container">
        <div className="current-commissioner-section">
          <div className="commissioner-card">
            <div className="commissioner-image-container">
              <img src="chris.jpg" alt="Commissioner Chris" className="commissioner-image" />
              <div className="image-glow"></div>
            </div>
            <div className="commissioner-info">
              <div className="commissioner-role">Current Commissioner</div>
              <h2 className="commissioner-name">Chris Mez</h2>
              <div className="commissioner-details">
                <div className="detail-item">
                  <span className="detail-icon">🏈</span>
                  <span className="detail-label">League Manager</span>
                </div>
                <div className="detail-item">
                  <span className="detail-icon">⚖️</span>
                  <span className="detail-label">Rule Enforcer</span>
                </div>
                <div className="detail-item">
                  <span className="detail-icon">🤝</span>
                  <span className="detail-label">Trade Mediator</span>
                </div>
              </div>
              <div className="commissioner-contact">
                <div className="contact-item">
                  <span className="contact-icon">📧</span>
                  <span className="contact-text">whateverchrissemailsi@gmail.com</span>
                </div>
                <div className="contact-item">
                  <span className="contact-icon">📱</span>
                  <span className="contact-text">(407) 780-0840</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="leadership-stats">
          <div className="stat-card">
            <div className="stat-icon">👥</div>
            <div className="stat-number">12</div>
            <div className="stat-label">Team Owners</div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">🏆</div>
            <div className="stat-number">8</div>
            <div className="stat-label">Seasons</div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">💰</div>
            <div className="stat-number">$2,400</div>
            <div className="stat-label">Prize Pool</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Leadership;
